export default "__VITE_ASSET__DLFPJLQI__"